import React from 'react'
import { CompareCredit } from '../../../../types/compare-credit'
import { endsInS, nextImageHelper, supify } from '../../../utils'
import Link from 'next/link'

import { CardArt, LinkToRedirect } from '../../'
import { ApplyNowIcon } from 'components/link-to-redirect/ApplyNowIcon'
import { clickRatesAndFees } from '../../../clients/segment'

export function CardTile(props: {
  orderId: string
  card: CompareCredit.FormattedCard
  categoryId: string
  externalId: string
  referencedCards: null | Record<string, CompareCredit.Entity>
}) {
  const { card, categoryId, externalId, orderId } = props

  return (
    <>
      <div className="w-full / mb-0.5">
        <div className="c-card-table-hori__card-art inline-block w-3/4">
          <LinkToRedirect
            externalId={externalId}
            linkParams={card.applyNowLinkParameters}
            orderId={orderId}
            slug={card.slug}
          >
            <div className="c-card-art / relative flex w-full / text-center / rounded-sm overflow-hidden">
              <span className="c-card-art__content / absolute / flex flex-wrap content-center items-center / z-10 left-0 / w-full h-full text-white text-fs13">
                <span className="w-full mb-0">
                  <span className="inline-block w-6 lg:w-4">
                    <ApplyNowIcon
                      height={32}
                      width={32}
                      style={nextImageHelper.responsive}
                      sizes="100vw"
                    />
                  </span>
                </span>
                <span className="w-full -mt-1 font-semibold">Apply Now</span>
              </span>
              <CardArt
                _rev={card._rev}
                cardArt={card.cardArt}
                imgClasses="relative z-0 w-full  h-full object-cover top-0"
                issuer={card.issuer.slug.current}
                name={card.name}
                orderId={orderId}
                slug={card.slug}
                categoryId={categoryId}
                externalId={externalId}
              />
            </div>
          </LinkToRedirect>
        </div>
      </div>
      <div className="mb-2 lg:mb-0 / leading-snug">
        <div className="c-card-table-hori__name / text-primary-mid font-semibold / hover:text-primary-bright">
          <LinkToRedirect
            externalId={externalId}
            linkParams={card.applyNowLinkParameters}
            orderId={orderId}
            slug={card.slug}
          >
            <div
              className="text-primary-mid hover:text-primary-bright"
              dangerouslySetInnerHTML={{ __html: supify(card.name) }}
            />
          </LinkToRedirect>
        </div>
      </div>
      <div className="lg:hidden">
        <LinkToRedirect
          externalId={externalId}
          linkParams={card.applyNowLinkParameters}
          orderId={orderId}
          slug={card.slug}
        >
          <div className="c-btn c-btn--primary / mb-2">
            Apply Now
            <span className="w-4 h-4 / ml-2">
              <ApplyNowIcon
                width={16}
                height={16}
                aria-hidden={true}
                sizes="100vw"
                style={nextImageHelper.responsive}
              />
            </span>
          </div>
        </LinkToRedirect>
        <p className="mb-0.5 / text-fs12 text-slate-600 / text-center leading-tight / text-shadow">
          {card.issuerSecureSite
            ? card.issuerSecureSite
            : `on ${card.issuer.name}'${
                !endsInS(card.issuer.name) ? `s` : ''
              } secure site`}
        </p>
        {card.ratesAndFees && card.ratesAndFees && (
          <div className="w-full / text-center h-6">
            {card.ratesAndFees && card.ratesAndFees !== 'N/A' && (
              <Link
                className="text-primary-bright text-xs"
                href={card.ratesAndFees}
                onClick={() => {
                  clickRatesAndFees({
                    applyNowLink: card.applyNowLink,
                    component: 'Card Comparison Table Horizontal',
                    name: card.name,
                    url: window.location.href,
                  })
                }}
                rel="noopener noreferrer"
                target="_blank"
              >
                Rates &amp; Fees
              </Link>
            )}
            {card.issuer.slug.current === 'american-express' && (
              <p className="text-fs10 text-gray-600 / text-center / mb-3 md:mb-1 / w-full leading-4">
                Terms Apply
              </p>
            )}
          </div>
        )}
      </div>
    </>
  )
}
